import React, { useState, useEffect } from 'react';

import { format } from 'date-fns';
import { NotificationContainer } from 'react-notifications';
import api from '../../services/api';
import CategoryManagerContext from './CategoryManagerContext';

import NavBar from '../../components/NavBar';
import Loader from '../../components/Loader';
import Error from '../../components/Error';
import Line from '../../components/Line';
import NavTabsGeneral from '../../components/NavTabsGeneral';

import TabInfo from './Tabs/Info';
import TabImage from './Tabs/Image';
import TabMedia from './Tabs/Media';

import * as S from './styles';

const CategoryManager = props => {
  const [isLoading, setLoading] = useState(true);
  const [isError, setError] = useState(false);
  const [isContent, setContent] = useState(false);
  const [isNewData, setNewData] = useState(false);
  const [isNewDataId, setNewDataId] = useState('');
  const [objData, setData] = useState({});

  const auxFormatData = data => {
    data.id = data.catId;
    switch (data.catStatus) {
      case 0:
        data._catStatus = 'Active';
        break;
      case 2:
        data._catStatus = 'Disabled';
        break;
      default:
        data._catStatus = 'Disabled';
        break;
    }
    data._catDateCreated = format(new Date(data.catDateCreated), 'MM/dd/yyyy');
    data._catDateUpdated = format(new Date(data.catDateUpdated), 'MM/dd/yyyy');
    return data;
  };

  useEffect(() => {
    async function loadData() {
      const {
        match: {
          params: { id },
        },
      } = props;

      if (id === 'new') {
        // New Data
        const {
          location: {
            search,
          },
        } = props;
        if (search !== '') {
          const parameterCreateCategory = search.substr(6);
          setNewDataId(parameterCreateCategory);
        } else {
          setNewDataId('undefined');
        }
        setNewData(true);
        viewContent();
      } else {
        const apiGetData = api('GET', `/category/${id}`, null);

        const resGetData = await apiGetData;
        const {
          data: { resData },
        } = resGetData;
        console.log(resData);
        setData(auxFormatData(resData));
        viewContent();
      }
    }
    try {
      loadData();
    } catch (error) {
      viewError();
    }
  }, []);

  const viewData = () => {
    return (
      <S.DivData>
        <NavTabsGeneral
          propContext={objData}
          propTabs={[
            {
              title: 'Info',
              component: <TabInfo propData={objData} propNewData={isNewData} propNewDataId={isNewDataId} />,
            },
            !isNewData && {
              title: 'Images',
              component: <TabImage propData={objData} />,
            },
            !isNewData && {
              title: 'Medias',
              component: <TabMedia propData={objData} />,
            },
          ]}
        />
      </S.DivData>
    );
  };

  const viewLoading = status => {
    if (status === undefined) {
      console.log('type A');
      setContent(false);
      setError(false);
      setLoading(true);
    } else {
      console.log('type B');
      setLoading(status);
    }
  };

  const viewError = () => {
    setContent(false);
    setLoading(false);
    setError(true);
  };

  const viewContent = () => {
    setLoading(false);
    setError(false);
    setContent(true);
  };

  return (
    <>
      <NavBar />
      <S.Container>
        <S.ContainerHeader>
          <S.Title>Category</S.Title>
          <Line />
        </S.ContainerHeader>
        <S.ContainerContent>
          <CategoryManagerContext.Provider
            value={{ viewLoading, viewError, viewContent }}
          >
            {isLoading && <Loader />}
            {isError && <Error />}
            {isContent && viewData()}
            {/* {isLoading ? <Loader /> : viewData()} */}
          </CategoryManagerContext.Provider>
        </S.ContainerContent>
      </S.Container>
      <NotificationContainer />
    </>
  );
};

export default CategoryManager;
